const initialState = {
    data: [],
    page: 1,
    searchAddress: "",
    searchCriteria: {},
    lastPage: false
};

export default function reducerUser(state = initialState, action) {
    switch (action.type) {
        case "FRESH_SEARCH":
            return {
                ...state,
                data: action.payload.data,
                page: action.payload.page,
                searchCriteria: action.payload.searchCriteria,
                lastPage: false
            };
        case "PAGE_SEARCH":
            return {
                ...state,
                data: state.data.concat(action.payload.data),
                page: action.payload.page,
                searchCriteria: action.payload.searchCriteria,
                lastPage: false
            };
        case "SEARCH_ADDRESS":
            return {
                ...state,
                searchAddress: action.payload.searchAddress
            }
        case "CHANGE_PAGE":
            return {
                ...state,
                page: action.payload.page,
                lastPage: false
            }
        case "SET_LAST_PAGE":
            return {
                ...state,
                lastPage: true
            }
        default:
            return state;
    }
}